export interface EmissionResume {
  fullname: string;
  car: {
    model: string;
    brand: string;
    year: string;
  };
  vinNumber: string;
  invoiceName: string;
  invoiceBase64: string;
  newVinNumber: string;
  newInvoiceName: string;
  newInvoiceBase64: string;

  productCoreId: string;
  policyNumber: number;
  customerFullName: string;
  customerEmail: string;
  brokerEmail: string;

  id: number;
  urlSalt: string;
  productId: string;
  policyId: string;
  operationNumber: string;
}

export const makeEmptyEmissionResume = (): EmissionResume => ({
  fullname: '',
  car: {
    model: '',
    brand: '',
    year: '',
  },
  vinNumber: '',
  invoiceName: '',
  invoiceBase64: '',
  newVinNumber: '',
  newInvoiceName: '',
  newInvoiceBase64: '',

  productCoreId: '',
  policyNumber: 0,
  customerFullName: '',
  customerEmail: '',
  brokerEmail: '',

  id: 0,
  urlSalt: '',
  productId: '',
  policyId: '',
  operationNumber: '',
});
